import { connect, ConnectedProps } from 'react-redux'
import TableProducts from '../../../../../../../../specificComponents/Product/Tables/TableProducts'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { BrandsPayload } from '../../../../../../../../utils/reducers/products/brands'
import { CategoriesPayload } from '../../../../../../../../utils/reducers/products/categories'
import { CloseLateralModalSimple, ModalFullCentered } from '../../../../../../../Modal'
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { ModalEditComponentProps } from '../../../../../../../ModalsLayouts/types'
import { SpecificPriceRulesPayload } from '../../../../../../../../utils/reducers/products/specificPriceRules'
import { CollectionsPayload } from '../../../../../../../../utils/reducers/products/collections'


type ProductListingModalProps = ReduxTableProducts & ModalEditComponentProps & {}

const ProductListingModal: React.FC<ProductListingModalProps> = ({...rest}) => {
    return (
        <ModalFullCentered opened={true} setOpened={() => rest.setOpened(null)} className='shortcut_modal'>
            <CloseLateralModalSimple onClose={()=> rest.setOpened(null)}/>
            <TableProductsConnect setTableInstance={() => { }} userPermissions={getUserPermissions('product.profile.main') || { n: 1, permission: 'read' }} tableInstance={null} {...rest} setOpened={() => rest.setOpened(null)} onRowClick={() => rest.setOpened(null)}/>
        </ModalFullCentered>
    )
}

const tableProductsDispatch = {
    setCategories: (payload: CategoriesPayload) => ({ type: 'CHANGE_CATEGORIES', payload }),
    setBrands: (payload: BrandsPayload) => ({ type: 'CHANGE_BRANDS', payload }),
    setCollections: (payload: CollectionsPayload) => ({ type: 'CHANGE_COLLECTIONS', payload }),
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}
const mapTableProductsConnector = (state: AllReduxPayloads) => ({ categories: state.categories, brands: state.brands, specificPriceRules: state.specificPriceRules, collections: state.collections })
const tableProductsConnect = connect(mapTableProductsConnector, tableProductsDispatch)
type ReduxTableProducts = ConnectedProps<typeof tableProductsConnect>

const tableProductsConnectLoading = withLoading(TableProducts, [{ fetchUrl: '/api/app/product/category/getAllCategories', propName: 'categories', setFunctionName: 'setCategories' }, { fetchUrl: '/api/app/product/brand/getAllBrands', propName: 'brands', setFunctionName: 'setBrands' }, { fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }, { fetchUrl: '/api/app/product/collection/getAllCollections', propName: 'collections', setFunctionName: 'setCollections' },])
const TableProductsConnect = tableProductsConnect(tableProductsConnectLoading)


export default ProductListingModal